<template>
  <layout-main-inner :title="cert.certName">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="createCertFile">新建证书文件</el-button>
      </template>
      <el-table
        border
        :data="cert.certFiles">
        <el-table-column
          label="有效期"
          :resizable="false"
          width="200">
          <template slot-scope="{row}">
            {{ row.certBeginTime | dateformat('YYYY/MM/DD') }} - {{ row.certEndTime | dateformat('YYYY/MM/DD') }}
          </template>
        </el-table-column>
        <el-table-column
          label="证书图片"
          :resizable="false">
          <template slot-scope="{row}">
            <image-list :fileList="row.certFile" />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="150">
          <template slot-scope="{row}">
            <el-button
              type="danger"
              @click="deleteCertFile(row)">删除</el-button>
            <el-button
              type="warning"
              @click="updateCertFile(row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-card-wrap>
    <template slot="footer">
      <!-- <back-button ref="back" /> -->
    </template>
    <certificate-modal
      ref="modal"
      :certId="$route.query.certId"
      :certName="cert.certName"
      :current="current"
      :fetch="fetchCertFiles" />
  </layout-main-inner>
</template>

<script>
import CertificateModal from './certificate-modal.vue'
import ImageList from '@/components/public/image-list.vue'
export default {
  name: 'CertificateDetail',
  components: { CertificateModal, ImageList },
  data() {
    return {
      loading: false,
      cert: {},
      current: {}
    }
  },
  mounted() {
    this.fetchCertFiles()
  },
  methods: {
    createCertFile() {
      this.$refs.modal.toggleModal(true)
    },
    fetchCertFiles() {
      this.loading = true
      this.$store.dispatch('certificate/getcertificate', {
        payload: {
          vendorId: this.$route.query.vendorId,
          certId: this.$route.query.certId
        },
        success: (res) => {
          this.loading = false
          res.data.certFiles.forEach(item => {
            item.certFile = item.certFile.split(',').map(o => ({ url: o }))
            return item
          })
          this.cert = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteCertFile(row) {
      this.$confirm('此操作将永久删除该证书文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('certificate/deletecertificatefile', {
            payload: {
              certId: row.certId,
              vendorId: this.cert.vendorId,
              certFileId: row.certFileId
            },
            success: () => {
              this.loading = false
              this.fetchCertFiles()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    updateCertFile(row) {
      this.current = {
        certFileId: row.certFileId,
        certFile: row.certFile,
        time: [new Date(row.certBeginTime), new Date(row.certEndTime)]
      }
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
